// extracted by mini-css-extract-plugin
module.exports = {"paymentListHeader":"gR","secondaryTitle":"hR"};